<template>
  <v-bottom-navigation
    v-if="$vuetify.breakpoint.xsOnly"
    app
    height="68"
    class="bottom-nav"
  >
    <!--
      Aufbau wie in v3 (shared/components/BottomNav.vue): zwei Ziele, in der
      Mitte "Erfassen" als erhöhter Knopf, rechts Profil und "Mehr".
      Im Vereinskontext gibt es nichts zu erfassen, dort stehen vier Ziele.
      Eigene Links statt v-btn: v-btn meldet sich bei der Button-Gruppe an,
      und die merkt sich den zuletzt getippten Knopf, auch wenn die Seite
      danach wechselt.
    -->
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="bottom-nav__item"
      :class="{
        'bottom-nav__item--primary': item.primary,
        'bottom-nav__item--active': !item.primary && isActive(item.to)
      }"
    >
      <span v-if="item.primary" class="bottom-nav__fab">
        <v-icon color="white">{{ item.icon }}</v-icon>
      </span>
      <v-icon v-else>{{ item.icon }}</v-icon>
      <span class="bottom-nav__label">{{ item.text }}</span>
    </router-link>

    <button
      type="button"
      class="bottom-nav__item"
      @click.stop="comp_NavigationDrawer = !comp_NavigationDrawer"
    >
      <v-icon>mdi-menu</v-icon>
      <span class="bottom-nav__label">Mehr</span>
    </button>
  </v-bottom-navigation>
</template>

<script>
const userItems = [
  { text: 'Schießbuch', to: '/user/shootingbook', icon: 'mdi-book-open-variant' },
  { text: 'Waffen', to: '/user/weapon', icon: 'mdi-pistol' },
  { text: 'Erfassen', to: '/user/recordtime', icon: 'mdi-plus', primary: true },
  { text: 'Profil', to: '/user/profil', icon: 'mdi-account-outline' }
];

const clubItems = [
  { text: 'Schießbuch', to: '/club/shootingbook', icon: 'mdi-book-open-variant' },
  { text: 'Waffen', to: '/club/weapon', icon: 'mdi-pistol' },
  { text: 'Mitglieder', to: '/club/members', icon: 'mdi-account-group' },
  { text: 'Profil', to: '/club/profil', icon: 'mdi-account-outline' }
];

export default {
  name: "BottomNav",

  computed: {
    items() {
      return this.$store.getters["UserAuth/isLoggedIn"] ? userItems : clubItems;
    },
    comp_NavigationDrawer: {
      get() {
        return this.$store.getters["GeneralApp/GET_NavbarDrawer"];
      },
      set(val) {
        this.$store.state.GeneralApp.NavigationDrawer = val;
      }
    }
  },

  methods: {
    isActive(to) {
      return this.$route.path === to;
    }
  }
};
</script>

<style scoped>
.bottom-nav {
  overflow: visible;
  /* Knöpfe etwas vom unteren Rand weg (abgerundete Ecken, Home-Leiste);
     safe-area greift nur, falls viewport-fit=cover mal gesetzt wird */
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  height: calc(68px + env(safe-area-inset-bottom)) !important;
}

.bottom-nav__item {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
  background: none;
  border: 0;
}

.bottom-nav__item .v-icon {
  color: inherit;
}

/* Nicht nur Farbe: der Streifen oben markiert das aktive Ziel auch bei
   Rot-Grün-Schwäche. */
.bottom-nav__item--active {
  color: #228b22;
  font-weight: 500;
}

.bottom-nav__item--active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 12px;
  right: 12px;
  height: 2px;
  border-radius: 2px;
  background: #32cd32;
}

.bottom-nav__label {
  width: 100%;
  font-size: 0.75rem;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bottom-nav__item--primary .bottom-nav__label {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.bottom-nav__fab {
  margin-top: -20px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #32cd32;
  box-shadow: 0 0 0 4px #fff, 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: transform 0.1s;
}

.bottom-nav__item--primary:active .bottom-nav__fab {
  transform: scale(0.95);
}
</style>
